<template>
  <div class="ItemList">
    <draggable
      class="item"
      v-for="item in items"
      :key="item.key"
      :x="item.x"
      :y="item.y"
      :resizable="false"
      :style="{
        backgroundImage: get(item.key) ? url(get(item.key).imageKey) : null
      }"
    >
      <!-- @change="(x, y) => onChange(item.key, x, y)" -->
      <div class="inner" @dblclick="showDetail(item.key)">
        <faicon class="icon" icon="times-circle" @click="remove(item.key)" />
        <p v-if="get(item.key)" class="name m-ellipsis" v-text="get(item.key).text"></p>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from '../common/draggable'

export default {
  components: { draggable },
  computed: {
    items() {
      return this.$store.getters['itemList/$items']
    },
    src() {
      return this.$store.getters['images/getSrc']
    },
    url() {
      return this.$store.getters['images/getBackgroundUrl']
    },
    get() {
      return this.$store.getters['items/$get']
    }
  },
  methods: {
    remove(key) {
      this.$store.dispatch('itemList/$remove', key)
    },
    onChange(key, x, y) {
      this.$store.dispatch('itemList/setPos', { key, data: { x, y } })
    },
    showDetail(key) {
      this.$store.commit('items/$checkout', key)
    }
  }
}
</script>

<style scoped>
.ItemList {
  width: 0;
  height: 0;
  display: flex;
  position: absolute;
  top: 30px;
  left: 50%;
  /* z-index: 1; */
}
.item {
  border-radius: 2px;
  overflow: hidden;
  width: 60px;
  height: 60px;
  /* position: absolute; */
  display: flex;
  background-size: cover;
  /* align-items: center; */
  /* justify-content: center; */
}
.item .inner {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  cursor: pointer;
}
.item .name {
  box-sizing: border-box;
  padding: 2px 4px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 10px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
}
.item .icon {
  position: absolute;
  top: 2px;
  right: 2px;
  color: #444;
  width: 10px;
  height: 10px;
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.2));
}
</style>
